import { render, staticRenderFns } from "./DataTableSample.vue?vue&type=template&id=4f9fdfce&scoped=true&"
import script from "./DataTableSample.vue?vue&type=script&lang=js&"
export * from "./DataTableSample.vue?vue&type=script&lang=js&"
import style0 from "./DataTableSample.vue?vue&type=style&index=0&id=4f9fdfce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9fdfce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
